// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bg-regular[data-v-66813894]{background-color:#67961c}.timeline-block[data-v-66813894]{top:0;bottom:0;height:30px;margin:auto}li>p.b-dropdown-text[data-v-66813894]{padding:.25rem 1.2rem;text-wrap:nowrap}", ""]);
// Exports
module.exports = exports;
